import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const displayErrorModal = () => {
  const {
    nav: {
      maintenance
    }
  } = store.getState();
  if (maintenance) {
    return;
  }
  store.dispatch({
    type: SHOW_MODAL,
    modalProps: {
      details: i18n.t('Global.modals.errorCommunicatingServer.body'),
      testID: 'ApiErrorModal'
    }
  });
};
mediator.subscribe('error:display', displayErrorModal);